import React from 'react';
import { useIntl } from 'react-intl';
import { Grid, Button, FormLabel, Tooltip } from '@material-ui/core';
import { func, object, string, bool, shape } from 'prop-types';

import { FormTextField, FormSelect } from '../../../../components';
import { getI18n, getI18nFormattedMessage } from '../../../../utils/intl';


export const FilterByName = (props) => (
    <Grid item md={3} sm={3} xs={12}>
        <FormTextField
        {...props}
        id="product-details-apps-filter-by-name"
        data-apim-test="product-details-apps-filter-by-name"
        />
    </Grid>
);

export const FilterByOrgs = (props) => (
  <Grid item md={3} sm={3} xs={12}>
      <FormTextField
      {...props}
      id="product-details-apps-filter-by-orgs"
      data-apim-test="product-details-apps-filter-by-orgs"
      />
  </Grid>
);

export const FilterSeparator = (props) => (
  <Grid item md={props.col} />
);

FilterSeparator.propTypes = {
  col: string,
}

export const FilterByStatus = (props) => (
  <Grid item md={3} sm={3} xs={12}>
    <FormSelect
      {...props}
      id="product-details-apps-filter-by-status"
      data-apim-test="product-details-apps-filter-by-status"
    />
</Grid>
)

export const TypeHeaderTooltip = ({ tooltipLabel } ) => {
  return (
    <div>
      <div>
        { tooltipLabel }
      </div>
    </div>
  );
}
TypeHeaderTooltip.propTypes = {
  tooltipLabel: string,
};
export const TooltipIcon = ({ classes, label, tooltipLabel, content }) => (
  <div className={classes.helpIconContainer}>
    <div>
      {label}
    </div>
    <Tooltip title={<TypeHeaderTooltip tooltipLabel={tooltipLabel}/>} placement="bottom">
      {content}
    </Tooltip>
  </div>
);
TooltipIcon.propTypes = {
  tooltipLabel: string,
  classes: object,
  label: string,
  content: object,
};

export const AddButton = (props) => (
  <Grid
    item md={2} sm={2} xs={12}
    id="product-details-add-apps-container"
    data-apim-test="product-details-add-apps-container"
    data-layer7-test="product-details-add-apps-container"
  >
      <Button
        id="product-details-add-app"
        data-apim-test="product-details-add-app"
        data-layer7-test="product-details-add-app"
        color="primary"
        variant="contained"
        className={props.activeButton}
        onClick={(e) => props.onClickAssign(e, '')}
        disabled={props.disabled}
      >
        {getI18nFormattedMessage('label.application.add')}
      </Button>
  </Grid>
);

AddButton.propTypes = {
  activeButton: shape({}),
  onClickAssign: func,
  disabled: bool,
};

export const HeaderActionButtons = (props) => {
  const {
    classes = {},
    bulkActionsItemsCount,
    onAddAccessTier,
    onRemoveAccess,
    disableRemoveAccess,
    tiersList,
    selectedTier,
    onChangeTier,
    hasApplyTierLabel,
    isRemoveAccess,
    hasUpdateTier,
    onBulkTierSelect,
    hasAddApp = false,
    onRemoveAssign,
    modifiedRecords,
  } = props;

  const id = 'product-app-header-buttons'
  const intl = getI18n(useIntl());

  return (
    <>
        <FormLabel className={ classes.actionsLabel }>
            {intl.getI18nMessage('label.organization.apiaccess.actions.label', { count: bulkActionsItemsCount })}
        </FormLabel>
        <Grid item container md={12} sm={12} xs={12} className={classes.headerButtons}>
            <Grid item xs={3}>
              <FormSelect
                {...props}
                handleChange={onChangeTier}
                id={`${id}-tiers-list`}
                data-apim-test={`${id}-tiers-list`}
                data={tiersList}
                value={selectedTier}
                noNoneOption
                noNativeSelect
                fieldContainerClass={classes.selectContainer}
                disabled={!hasUpdateTier}
              />
            </Grid>
            <Grid item xs={9} className={classes.buttonContainer}>
              <Button
                variant="contained" color="secondary"
                className={classes.addButton}
                id={`${id}-add-access-tier`}
                data-apim-test={`${id}-add-access-tier`}
                data-layer7-test={`${id}-add-access-tier`}
                onClick={onAddAccessTier}
                disabled={!hasUpdateTier}
              >
                {hasApplyTierLabel ?
                  intl.getI18nMessage('label.assign.set.tier') :
                  intl.getI18nMessage('label.set.tier')
                }
              </Button>
              <Button
                variant="outlined" color="secondary"
                className={classes.moreButton}
                id={`${id}-more-tier-info`}
                data-apim-test={`${id}-rmore-tier-info`}
                data-layer7-test={`${id}-more-tier-info`}
                onClick={onBulkTierSelect}
              >
                {intl.getI18nMessage('label.more.tier.info')}
              </Button>
              <Button
                variant="contained" color="secondary"
                className={classes.removeButton}
                id={`${id}-remove-access`}
                data-apim-test={`${id}-remove-access`}
                data-layer7-test={`${id}-remove-access`}
                onClick={onRemoveAccess}
                disabled={disableRemoveAccess}
              >
                {isRemoveAccess ? intl.getI18nMessage('label.unassign')
                  : intl.getI18nMessage('label.assign')}
              </Button>
              {hasAddApp &&
                <Button
                  variant="contained" color="secondary"
                  className={classes.removeButton}
                  id={`${id}-remove-access`}
                  data-apim-test={`${id}-remove-access`}
                  data-layer7-test={`${id}-remove-access`}
                  onClick={onRemoveAssign}
                  disabled={modifiedRecords<1}
                >
                {intl.getI18nMessage('label.unassign')}
              </Button>
              }
            </Grid>
        </Grid>
    </>
  );
}

HeaderActionButtons.propTypes = {
  classes: object,
  onAddAccessTier: func,
  onRemoveAccess: func,
  disableRemoveAccess: bool,
  bulkActionsItemsCount: string,
  tiersList: shape({}),
  selectedTier: string,
  onChangeTier: func,
  hasApplyTierLabel: bool,
  isRemoveAccess: bool,
  hasUpdateTier: bool,
  onBulkTierSelect: func,
  hasAddApp: bool,
  onRemoveAssign: func,
  modifiedRecords: string,
};